"use strict";
import _ from "underscore";
import Api from "../api/api";
import documentTypes from "./documents/types";
import Auth from "../util/auth";
export function types() {
  return documentTypes.types(Auth._currentUser);
}
function validMappedType(document) {
  let type;
  if (document && (type = document.type || document.document_type)) {
    return _typesMap()[type];
  }
}
export function title(document) {
  if (document.type_name) {
    return document.type_name;
  }
  const mapped = validMappedType(document);
  return mapped ? mapped.name : "Unidentified";
}
export function titleForType(type, defaultTitle = "Unidentified") {
  const mapped = _typesMap()[type];
  return mapped ? mapped.name : defaultTitle;
}
export function activeTypes() {
  if (Api.Account.useDocumentTypeHotkeys()) {
    var enabledTypes2 = enabledTypesFunc();
    var documentTypeHotkeysOrdering = Api.Account.currentSettings().document_type_hotkeys_ordering;
    if (!documentTypeHotkeysOrdering || documentTypeHotkeysOrdering.length === 0) {
      return enabledTypes2;
    }
    var mappedOrdering = documentTypeHotkeysOrdering.map(
      (typeValue) => enabledTypes2.find((doctype) => doctype.value === typeValue)
    ).filter((docType) => !!docType);
    var remainingEnabledTypes = enabledTypes2.filter(
      (doctype) => !documentTypeHotkeysOrdering.includes(doctype.value)
    );
    return mappedOrdering.concat(remainingEnabledTypes);
  }
  return enabledTypesFunc();
}
function enabledTypes() {
  if (Api.Account.current().enabled_document_type_names) {
    return _.sortBy(
      Api.Account.current().enabled_document_type_names,
      _.property("name")
    );
  }
  var enabled = Api.Account.currentSettings().enabled_document_types;
  var enabledTypes2 = _.select(types(), function(type) {
    return enabled.indexOf(type.value) >= 0;
  });
  return _.sortBy(enabledTypes2, _.property("name"));
}
const enabledTypesFunc = enabledTypes;
const _typesMap = _.memoize(function() {
  var typesMap = {};
  _.each(types(), function(type) {
    typesMap[type.value] = type;
  });
  typesMap["factoringAssignment"] = typesMap["noticeOfAssignment"];
  typesMap["loadTender"] = typesMap["rateConfirmation"];
  return typesMap;
});
